import { FormEvent, useEffect, useRef, useState } from 'react';

import { AnimatePresence, motion } from "framer-motion";

import * as S from './styles';


import { useTranslation } from 'react-i18next';
import { formatToBRL } from 'base/src/utils/mathUtil';
import { RootStateCarteira } from '../../../../../store/carteiraReducer';
import { AbrirBoleto, DepositoBoleto, GetBoletoSemelhante, ResetBoleto } from '../../../../../store/deposito/actions/depositoAction';
import DepositoContainer from '../../../../../containers/deposito/depositoContainer';
import assets from 'base/src/assets/assets';
import { FormToObject } from 'domain/utils/FormUtils';
import { toast } from 'react-toastify';
import { Forms } from 'base/src/components/Form';
import { Button } from 'base/src/components/Button';
import { DepositoBoletoRequest } from '../../../../../types/deposito/depositoBoletoRequest';
import { useNavigate } from "react-router-dom";

import 'simplebar-react/dist/simplebar.min.css';
import Divider from 'base/src/components/Divider';
import { useTheme } from 'base/src/utils/context/themeContext';
import { connectUtil, PropsFromRedux } from "base/src/utils/reduxUtil";
import { ModalClose } from 'base/src/components/Modal';
import { BoletoResponse } from '../../../../../types/boleto/boletoResponse';
import { formatDateTime } from 'base/src/utils/stringUtil';


const connector = connectUtil(
  (state: RootStateCarteira) => ({
    CarteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
    BoletoGerado: state.DepositoReducer.BoletoGerado
  }),
  { DepositoBoleto, AbrirBoleto, ResetBoleto }
);

export interface PagamentoBoletoProps extends PropsFromRedux<typeof connector> {
  valorDeposito: number;
  valorTotal: number;
  meioPagamento: string | null;
  _container: DepositoContainer;
}

function PagamentoBoleto(props: PagamentoBoletoProps) {
  //const depositoContainer = props._container;
  const navigate = useNavigate();

  // const _userData = _UserData;
  const { theme } = useTheme();

  const [boletoSemelhante, setBoletoSemelhante] = useState<BoletoResponse | null | false>(false);

  // const [step, setStep] = useState(1);

  const initialState = {} as DepositoBoletoRequest
  const [request] = useState<DepositoBoletoRequest>(initialState as DepositoBoletoRequest)

  const { t } = useTranslation();

  const formRef = useRef<HTMLFormElement>(null);

  const [carregando, setCarregando] = useState(false)

  const [popupEnabled, setPopupEnabled] = useState<boolean | null>(null);

  // Verificar se popups estão habilitados
  useEffect(() => {
    checkPopupEnabled();
    HandleGetBoletoSemelhante(props.valorDeposito)
    props.ResetBoleto();
    setCarregando(false)
  }, []);

  async function HandleGetBoletoSemelhante(valor: number) {
    const r = await GetBoletoSemelhante(valor);
    setBoletoSemelhante(r as BoletoResponse | null);
  }

  function checkPopupEnabled() {
    const popup = window.open('', '_blank', 'width=1,height=1');
    if (!popup || popup.closed || typeof popup.closed === 'undefined') {
      setPopupEnabled(false);
    } else {
      setPopupEnabled(true);
      popup.close();
    }
  }

  function prosseguirBoletoSemelhante() {
    setBoletoSemelhante(null)
  }

  // function handleStep(value: number) {
  //   return () => setStep(value);
  // }

  function handleForm(event: FormEvent<HTMLFormElement>) {
    if (popupEnabled === false) {
      toast(t("Por favor, habilite os popups no seu navegador para continuar com o processo de pagamento."), { type: "warning" });
      return event.preventDefault();
    }

    const obj: DepositoBoletoRequest = FormToObject(new FormData(event.currentTarget), request)
    obj.Valor = props.valorDeposito;


    // toast(t("" + props.valorTotal), {type:"info"})
    // toast(t("" + props.valorDeposito), {type:"info"})


    // obj.UsuarioID = _userData.Get<number>(UserDataBaseEnum.UsuarioID);
    // obj.CPF = obj.CPF.replace(/[^\d]/g, '');
    obj.CarteiraID = props.CarteiraUsuario[0].CarteiraID;

    if ((obj.Valor && obj.Valor != 0)) {
      setCarregando(true);
      props.DepositoBoleto(obj, ()=>setCarregando(false));

    } else {
      toast(t("Valor incorreto!"), { type: "info" })
    }
    event.preventDefault()
  }


  function redirectToHome() {
    navigate('/');
  }

  function handleOpenBoleto() {
    //props.BoletoGerado && props.AbrirBoleto(props.BoletoGerado)
    redirectToHome();
  }

  // function handleBoleto() {
  //   props.BoletoGerado && depositoContainer.AbrirBoleto(props.BoletoGerado)
  //   redirectToHome();
  // }


  function StepOne() {

    return (
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 100 }}
        transition={{ duration: 0.3 }}
      >


        <Forms formRef={formRef} handleForm={handleForm} >
          <S.Container>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <S.TitleContainer>
                <img src={assets.codigo_de_barras} alt="codbarra" style={{ width: 50 }} />
                <S.Column>
                  <S.Title>Boleto será gerado no valor de {formatToBRL(props.valorTotal)}</S.Title>
                </S.Column>
              </S.TitleContainer>
              <Divider orientation='horizontal' decorative color={theme.colors.border_grey} />
            </div>

            {boletoSemelhante == false ? (
              <S.Column>
                <S.Subtitle>Importante:</S.Subtitle>
                <S.Observacao>Buscando boleto semelhante</S.Observacao>
              </S.Column>
            ) : (
              <>
                {boletoSemelhante == null ? (
                  <>
                    <div style={{ display: 'flex', gap: 10 }}>
                      {props.BoletoGerado != undefined ? (
                        <S.Column style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                          <S.Subtitle>Boleto Gerado com sucesso!</S.Subtitle>
                          <ModalClose asChild>
                            <Button onClick={handleOpenBoleto} full size='md' >Fechar</Button>
                          </ModalClose>
                        </S.Column>
                      ) :
                        (
                          <>
                            <ModalClose asChild>
                              <Button full size='md' variant='tertiary' >Cancelar</Button>
                            </ModalClose>
                            <Button disabled={carregando} type='submit' full size='md'>Continuar</Button>
                          </>
                        )}
                    </div>
                  </>
                ) : (
                  <>
                    <S.Column>
                      <S.Subtitle>Importante:</S.Subtitle>
                      <S.Observacao>Existe um boleto semelhante gerado na data <S.Subtitle>{formatDateTime(boletoSemelhante.DataCriacao)}</S.Subtitle>, {props.valorDeposito.toString() != boletoSemelhante.Valor ? <>no valor de <S.Subtitle>{formatToBRL(boletoSemelhante.Valor)}</S.Subtitle> </> : ""}
                        gostaria de prosseguir assim mesmo?</S.Observacao>
                    
                    <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                      <ModalClose asChild>
                        <Button full size='md' variant='tertiary' >Cancelar</Button>
                      </ModalClose>
                      <Button type='button' variant='danger' onClick={prosseguirBoletoSemelhante} full size='md'>Prosseguir!</Button>
                      </div>
                    </S.Column>
                  </>
                )}


              </>)}

          </S.Container>
        </Forms>



      </motion.div >
    )
  }

  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars, no-unused-vars
  // function StepTwo(_props: { handleBack: () => void }) {
  //   return (
  //     <motion.div
  //       initial={{ opacity: 0, x: 100 }}
  //       animate={{ opacity: 1, x: 0 }}
  //       exit={{ opacity: 0, x: -100 }}
  //       transition={{ duration: 0.3 }}
  //     >
  //       <S.SetpTwoContainer >
  //         <S.Title>Finalize o pagamento usando o Pix!</S.Title>
  //         <span>Você pode utilizar a camera do seu celular para ler o QR Code ou copiar o código e pagar no  aplicativo de seu banco:</span>
  //         <S.Codewrapper >
  //           <img src='data:image/png;base64,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' style={{ width: 200 }} />

  //           <S.PixCode >
  //             <S.Code>
  //               00020126660014BR.GOV.BCB.PIX0114+5511999999995204000053039865802BR5925JOÃO DA SILVA6009SAO PAULO61080540900062130510ABC1234567898763
  //             </S.Code>
  //             <div style={{ alignSelf: 'flex-end' }}>
  //               <Button size='md'>Copiar código</Button>
  //             </div>
  //           </S.PixCode>

  //         </S.Codewrapper>
  //       </S.SetpTwoContainer>
  //     </motion.div >
  //   )
  // }

  return (
    <S.Container>
      <AnimatePresence>
        <StepOne />
        {/* {step === 2 && <StepTwo handleBack={handleStep(1)} />} */}
      </AnimatePresence>
    </S.Container >
  );
}

export default connector(PagamentoBoleto);